import { IconType } from '@/components/icon/helpers';

export type RouteKey = 'orgs' | 'partners' | 'partner' | 'admin-users' | 'root-users';

type RouteItem = {
  label: string;
  icon: IconType;
  link: string;
};

export const ROUTE_MAP: Record<RouteKey, RouteItem> = {
  orgs: {
    label: 'Organizations',
    icon: 'organization',
    link: '/orgs',
  },
  partners: {
    label: 'Partners',
    icon: 'organization',
    link: '/admin/partners',
  },
  partner: {
    label: 'Partner Settings',
    icon: 'partner',
    link: '/partner',
  },
  'admin-users': {
    label: 'Partner Admins',
    icon: 'group',
    link: '/admin-users',
  },
  'root-users': {
    label: 'Root Users',
    icon: 'group',
    link: '/root-users',
  },
};

export const getRoute = (key: RouteKey): RouteItem => ROUTE_MAP[key];
